import styled from "styled-components";
import { Wrapper, wrap } from 'AppReact';
import device from 'utils/device';

const outerTemplate = styled.div`
  padding: 16px;
  
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 340px;
  flex-grow: 1;
  @media ${device.tablet} {
    max-width: 360px;
  }
`;

const OuterWrapper = Wrapper(outerTemplate);

const innerTemplate = styled.div`
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  border: 1px solid #E7EBEB;
  position: relative;
  width: 100%;
  margin-top: 11px;
  @media ${device.tablet} {
    height: 378px;
  }
`;

const InnerWrapper = Wrapper(innerTemplate);

export default wrap(InnerWrapper, OuterWrapper);
